/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Proc_ArchitectInputs */

const en_proc_architect = /** @type {(inputs: Proc_ArchitectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ARCHITECT`)
};

const ar_proc_architect = /** @type {(inputs: Proc_ArchitectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التصميم`)
};

const bn_proc_architect = /** @type {(inputs: Proc_ArchitectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আর্কিটেক্ট`)
};

const de_proc_architect = /** @type {(inputs: Proc_ArchitectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ARCHITECT`)
};

const es_proc_architect = /** @type {(inputs: Proc_ArchitectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ARCHITECT`)
};

const fr_proc_architect = /** @type {(inputs: Proc_ArchitectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ARCHITECT`)
};

const pt_proc_architect = /** @type {(inputs: Proc_ArchitectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ARCHITECT`)
};

const zh_proc_architect = /** @type {(inputs: Proc_ArchitectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ARCHITECT`)
};

const tr_proc_architect = /** @type {(inputs: Proc_ArchitectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ARCHITECT`)
};

const ru_proc_architect = /** @type {(inputs: Proc_ArchitectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ARCHITECT`)
};

const pl_proc_architect = /** @type {(inputs: Proc_ArchitectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ARCHITECT`)
};

/**
* | output |
* | --- |
* | "ARCHITECT" |
*
* @param {Proc_ArchitectInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const proc_architect = /** @type {((inputs?: Proc_ArchitectInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Proc_ArchitectInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_proc_architect(inputs)
	if (locale === "bn") return bn_proc_architect(inputs)
	if (locale === "de") return de_proc_architect(inputs)
	if (locale === "es") return es_proc_architect(inputs)
	if (locale === "fr") return fr_proc_architect(inputs)
	if (locale === "pt") return pt_proc_architect(inputs)
	if (locale === "zh") return zh_proc_architect(inputs)
	if (locale === "tr") return tr_proc_architect(inputs)
	if (locale === "ru") return ru_proc_architect(inputs)
	if (locale === "pl") return pl_proc_architect(inputs)
	return en_proc_architect(inputs)
});